module.exports = __webpack_public_path__ + "public/images/about-9.ae4cf9c075a02e390858612f75a6fc7e.png";